import styled from "styled-components";
export const primary = "#341744";
export const secondary = "#ff8a23";
